import { useEffect, useState } from 'react'

/**
 * `<img>` that shows `fallback` when `src` is empty or fails to load (dead S3 object, old
 * WordPress URL…). `fallbackClassName` is appended only while the fallback is displayed.
 */
export default function FallbackImg({ src, fallback, className = '', fallbackClassName = '', ...rest }) {
    const [failed, setFailed] = useState(false)

    useEffect(() => {
        setFailed(false)
    }, [src])

    const showFallback = !src || failed

    return (
        <img
            {...rest}
            src={showFallback ? fallback : src}
            onError={showFallback ? undefined : () => setFailed(true)}
            className={showFallback ? `${className} ${fallbackClassName}`.trim() : className}
        />
    )
}
